import {
  createSuggestion,
  fetchSuggestions,
  fetchSuggestionById,
  fetchSuggestionsByContentType, 
  fetchSuggestionsByCategory,
  updateSuggestion,
  deleteSuggestion
} from './methods'

// Servisi dışa aktar
export const suggestionsService = {
  createSuggestion,
  fetchSuggestions,
  fetchSuggestionById,
  fetchSuggestionsByContentType,
  fetchSuggestionsByCategory,
  updateSuggestion,
  deleteSuggestion
}

export {
  createSuggestion,
  fetchSuggestions,
  fetchSuggestionById,
  fetchSuggestionsByContentType,
  fetchSuggestionsByCategory,
  updateSuggestion,
  deleteSuggestion
}